import script from "./subdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./subdetail.vue?vue&type=script&setup=true&lang=js"

import "./subdetail.vue?vue&type=style&index=0&id=5108b9e3&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5108b9e3"]])

export default __exports__